import { Box, DrawerV2Props, Flex, keyframes, styled, StyleSystemProps } from '@withjoy/joykit';
import { animationTransitionExt } from '@shared/utils/animationTransition';
import { TRANSITION_INTERVAL } from './ValuePropsTopBar.constants';

const TOP_BAR_HEIGHT = 48;

const gradients = keyframes`
0% {background-position: 0%}
100% {background-position: 100%}
`;

export const StyledValuePropBarVariantContainer = styled(Box)<{ $elementsAmount: number }>`
  background-size: 900% 100%;
  background-position: 0%;
  animation: ${gradients} ${({ $elementsAmount }) => TRANSITION_INTERVAL * $elementsAmount}ms linear infinite;
`;

export const StyledMainContainer = styled(Box)``;
export const StyledValuePropBarContainer = styled(Flex)``;
export const StyledTitle = styled(Box)``;
export const StyledValuePropCardsContainer = styled(Flex)``;
export const StyledValuePropCard = styled(Box)``;
export const StyledValuePropBarVariantWrapper = styled(Box)``;
export const StyledValuePropCardImg = styled(Box)``;

const mainContainerStyles: StyleSystemProps = {
  height: TOP_BAR_HEIGHT,
  position: 'relative',
  zIndex: 30
};

const valuePropBarVariantWrapperStyles: StyleSystemProps = {
  position: 'absolute',
  top: 0,
  width: '100%',
  height: TOP_BAR_HEIGHT
};

const styledCloseButtonContainerStyles: StyleSystemProps = {
  position: 'absolute',
  top: 0,
  right: 4,
  zIndex: 6
};

const valuePropBarVariantContainerStyles: StyleSystemProps = {
  position: 'relative',
  height: TOP_BAR_HEIGHT,
  zIndex: 5
};

const valuePropBarContainerStyles = (show: boolean): StyleSystemProps => ({
  position: 'relative',
  zIndex: 5,
  // color: 'white',
  width: '100%',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  columnGap: 3,
  opacity: show ? 1 : 0,
  // transitionDelay: show ? '1000ms' : '0ms',
  transition: animationTransitionExt({ property: 'opacity', duration: '800ms', timingFunction: 'ease-in', delay: show ? '800ms' : '0ms' }),
  pointerEvents: show ? 'none' : undefined
});

const drawerBodyStyles: StyleSystemProps = {
  height: '100%',
  paddingX: 7,
  paddingY: 10,
  display: 'flex',
  alignItems: 'center'
};

// Mobile

const valuePropCardsContainerMobileStyles: StyleSystemProps = {
  width: '100%',
  height: '100%',
  maxHeight: '100%',
  display: 'flex',
  flexDirection: 'column',
  rowGap: 5,
  justifyContent: 'center',
  alignItems: 'center'
};

// Desktop

const valuePropCardsContainerDesktopStyles: StyleSystemProps = {
  columnGap: 5,
  height: '100%',
  width: 'auto',
  justifyContent: 'center'
};

const valuePropCardsColumnDesktopStyles: StyleSystemProps = {
  flexDirection: 'column',
  rowGap: 5,
  height: '100%',
  justifyContent: 'center',
  _first: {
    alignItems: 'flex-end'
  },
  _last: {
    alignItems: 'flex-start',
    objectPosition: 'left'
  }
};

// Common

const valuePropCardStyles: StyleSystemProps = {
  width: 'auto',
  height: 'auto',
  overflow: 'hidden'
};

const valuePropCardImgStyles = (objectPosition: Maybe<string>): StyleSystemProps => ({
  objectFit: 'contain',
  objectPosition: objectPosition,
  width: '100%',
  height: '100%'
});

const storefrontNavigatorPlacementStyles: StyleSystemProps = {
  zIndex: 6,
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  color: 'white',
  height: '100%'
};

const findLinkPlacementStyles: StyleSystemProps = {
  zIndex: 6,
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  color: 'white',
  height: '100%',
  right: 8
};

export const styles = {
  mainContainer: mainContainerStyles,
  drawerBody: drawerBodyStyles,
  valuePropBarContainer: valuePropBarContainerStyles,
  valuePropBarVariantWrapper: valuePropBarVariantWrapperStyles,
  valuePropBarVariantContainer: valuePropBarVariantContainerStyles,
  valuePropCardsContainerMobile: valuePropCardsContainerMobileStyles,
  valuePropCardsContainerDesktop: valuePropCardsContainerDesktopStyles,
  valuePropCardsColumnDesktop: valuePropCardsColumnDesktopStyles,
  valuePropCard: valuePropCardStyles,
  valuePropCardImg: valuePropCardImgStyles,
  storefrontNavigatorPlacement: storefrontNavigatorPlacementStyles,
  findLinkPlacement: findLinkPlacementStyles,
  styledCloseButtonContainerStyles: styledCloseButtonContainerStyles
};

export const drawerOverrides: NonNullable<DrawerV2Props['overrides']> = {
  CloseButton: {
    props: {
      color: 'mono14'
    }
  }
};
